"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _DownloadGreyOutline = _interopRequireDefault(require("@druva-apps/orion-icons/lib/DownloadGreyOutline"));

var _input = _interopRequireDefault(require("../../input"));

var _tooltip = _interopRequireDefault(require("../../tooltip"));

var _popover = _interopRequireDefault(require("../../popover"));

var _toast = _interopRequireDefault(require("../../toast"));

var _button = _interopRequireDefault(require("../../button"));

var _actions = require("../actions");

var _context4 = require("../context");

var _exportToCsv = _interopRequireDefault(require("../exportToCsv"));

var _utils = require("../utils");

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var toggleArrayItem = function toggleArrayItem(arr, item) {
  var _context;

  return (0, _includes["default"])(arr).call(arr, item) ? (0, _filter["default"])(arr).call(arr, function (i) {
    return i !== item;
  }) : (0, _concat["default"])(_context = []).call(_context, (0, _toConsumableArray2["default"])(arr), [item]);
};

var PopoverBody = function PopoverBody(_ref) {
  var _context2;

  var tableRef = _ref.tableRef,
      onToastHandler = _ref.onToastHandler;

  var _useTable = (0, _context4.useTable)(),
      csvFileName = _useTable.csvFileName,
      data = _useTable.data,
      exportPopupMaxHeight = _useTable.exportPopupMaxHeight,
      exportableColumnKeys = _useTable.exportableColumnKeys,
      fireAction = _useTable.fireAction,
      onExportCSV = _useTable.onExportCSV,
      isLoading = _useTable.isLoading,
      enableCSVToastMessage = _useTable.enableCSVToastMessage;

  var columnManager = tableRef.current ? tableRef.current.getColumnManager() : null;

  var handleCSV = function handleCSV(exportableColumnObjects) {
    fireAction((0, _actions.isTableBusy)(true));
    (0, _setTimeout2["default"])(function () {
      (0, _exportToCsv["default"])(exportableColumnObjects, data, csvFileName, onExportCSV, fireAction, onToastHandler, enableCSVToastMessage);
    }, 150);
  };

  var allColumns = columnManager ? (0, _filter["default"])(_context2 = columnManager._columns).call(_context2, function (_ref2) {
    var key = _ref2.key;
    return key !== "__selection__" && key !== "__action__";
  }) : [];
  var disabledColumnKeys = [];
  var enabledColumnKeys = [];
  (0, _forEach["default"])(allColumns).call(allColumns, function (column) {
    if (typeof column.exportable === "undefined") {
      enabledColumnKeys.push(column.key);
    } else if (typeof column.exportable !== "undefined" && column.exportable === false) {
      disabledColumnKeys.push(column.key);
    }
  });
  var headerChecked = enabledColumnKeys.length === exportableColumnKeys.length;
  var exportableColumnObjects = (0, _filter["default"])(allColumns).call(allColumns, function (col) {
    return (0, _includes["default"])(exportableColumnKeys).call(exportableColumnKeys, col.key);
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "oui-d-flex oui-flex-column oui-justify-content-between"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "oui-p-2 oui-d-flex oui-border-bottom"
  }, /*#__PURE__*/_react["default"].createElement(_input["default"], {
    type: "checkbox",
    label: "Select All",
    checked: headerChecked,
    disabled: isLoading,
    onChange: function onChange(e) {
      var _context3;

      return fireAction((0, _actions.setExportableColumns)(e.target.checked ? (0, _map["default"])(_context3 = (0, _filter["default"])(allColumns).call(allColumns, function (c) {
        return !(0, _includes["default"])(disabledColumnKeys).call(disabledColumnKeys, c.key);
      })).call(_context3, function (c) {
        return c.key;
      }) : []));
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "oui-p-2 oui-overflow-auto",
    style: {
      maxHeight: "".concat(exportPopupMaxHeight, "px"),
      overflow: "auto"
    }
  }, (0, _map["default"])(allColumns).call(allColumns, function (column, idx) {
    return /*#__PURE__*/_react["default"].createElement(_input["default"], {
      key: "export-column-".concat(column.key),
      className: idx < allColumns.length - 1 ? "oui-mb-2" : "",
      type: "checkbox",
      label: (0, _utils.isString)(column.csvTitle) ? column.csvTitle : (0, _utils.isString)(column.title) ? column.title : "",
      checked: (0, _includes["default"])(exportableColumnKeys).call(exportableColumnKeys, column.key),
      disabled: (0, _includes["default"])(disabledColumnKeys).call(disabledColumnKeys, column.key) || isLoading,
      onChange: function onChange() {
        return fireAction((0, _actions.setExportableColumns)(toggleArrayItem(exportableColumnKeys, column.key)));
      }
    });
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "oui-p-2 oui-d-flex oui-justify-content-center oui-border-top"
  }, /*#__PURE__*/_react["default"].createElement(_button["default"], {
    label: "Download CSV",
    size: "sm",
    disabled: exportableColumnKeys.length === 0 || isLoading,
    onClick: function onClick() {
      return handleCSV(exportableColumnObjects);
    }
  })));
};

PopoverBody.propTypes = {
  tableRef: _propTypes["default"].object,
  onToastHandler: _propTypes["default"].func
};

var ExportCsv = function ExportCsv(_ref3) {
  var tableRef = _ref3.tableRef;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      showToast = _useState2[0],
      setShowToast = _useState2[1];

  var showToastHandler = function showToastHandler(toShow) {
    setShowToast(toShow);
  };

  return /*#__PURE__*/_react["default"].createElement("div", null, showToast && /*#__PURE__*/_react["default"].createElement(_toast["default"], {
    onClose: function onClose() {
      setShowToast(false);
    },
    alerts: [{
      message: "Data Export initiated. Data will be downloaded shortly.",
      type: "success"
    }],
    delay: 4000
  }), /*#__PURE__*/_react["default"].createElement(_popover["default"], {
    size: "auto",
    placement: "bottom",
    type: "uncontrolled",
    title: "Select Exportable Columns",
    bodyClassName: "oui-p-0",
    body: function body() {
      return /*#__PURE__*/_react["default"].createElement(PopoverBody, {
        tableRef: tableRef,
        onToastHandler: showToastHandler
      });
    },
    isOpen: true
  }, /*#__PURE__*/_react["default"].createElement(_tooltip["default"], {
    text: "Export Data To CSV"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    style: {
      borderRadius: "28px"
    },
    "aria-label": "Export As CSV",
    className: "orion-data-grid__navigation--empty-button oui-ml-3 data-grid-toolbar-button oui-w-auto oui-px-2"
  }, /*#__PURE__*/_react["default"].createElement(_DownloadGreyOutline["default"], {
    clickable: true,
    className: "oui-ml-1"
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "oui-pl-2 oui-text-truncate oui-pr-1",
    style: {
      fontSize: "0.75rem"
    }
  }, "CSV")))));
};

ExportCsv.propTypes = {
  tableRef: _propTypes["default"].object
};
var _default = ExportCsv;
exports["default"] = _default;